/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface BeneficialOwner {
  readonly first_name: string;
  readonly last_name: string;
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  readonly birth_date: string;
  readonly percentage_control: string;
  readonly status: string;
  readonly report_file_url: string;
}
